import React, { useCallback, useImperativeHandle, useState } from 'react';
import {
    DataGridPro, GridToolbarFilterButton
    , GridToolbarColumnsButton, GridToolbarExport, GridToolbarContainer
    , GridToolbarQuickFilter, useGridApiRef, GridFooterContainer, GridPagination
} from '@mui/x-data-grid-pro';
import { Tooltip, tooltipClasses, Typography, Grid, Box, Button, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import { toast } from 'react-toastify';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { GridFilterPanel, useGridApiContext } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';
import { isNewUi } from '../../redesign/uiMode';
import ActiveFilterChips from '../../redesign/grid/ActiveFilterChips';
import { withStatusClass, relaxColumns, pinActions, NoRowsOverlay } from '../../redesign/grid/gridLook';
import { datedColumns, formatDateText } from '../../redesign/grid/dates';
import { isSetupPage, setupColumns } from '../../redesign/grid/setupLook';
import { isDashboardPage, dashboardColumns } from '../../redesign/dashboard/dashboardLook';
import ParamsBar from '../../redesign/grid/ParamsBar';



//import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const Styles = theme => ({
    root: {
        '& .MuiDataGrid-main': {
            fontSize: '0.75rem',
            padding: '8px',
            color: 'inherit',
            border: 0,
            cursor: 'pointer',
            margin: 0,
            outline: 0,
            padding: 0,
            //userSelect: 'none',
            borderRadius: 0,
            textDecoration: 'none',
            backgroundColor: 'transparent',
            //height: 560
            //height:576
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            overflow: 'hidden !important',
            fontWeight: 500,
            whiteSpace: 'break-spaces',
            lineHeight: '1.4em',
            maxHeight: 'unset !important',
            height: 'fit-content'
        },
        '& .MuiDataGrid-footerContainer, & .MuiToolbar-gutters p': {
            color: 'inherit', fontSize: '0.75rem'
        },
        '&': {
            clear: 'both'
        },
        '&::before': {
            clear: 'both'
        },
        '&::after': {
            clear: 'both'
        },
        '& .MuiDataGrid-cell,& .MuiDataGrid-cell:focus': {
            whiteSpace: 'break-spaces !important',

            maxHeight: 'unset !important',
            padding: '0 10px !important',
            outline: 'none'
        },
        '& .MuiDataGrid-row': {
            maxHeight: 'unset !important'
        },
        '& .MuiDataGrid-cell .MuiInput-input, .MuiDataGrid-editInputCell': {
            color: '#414141',
            height: '29px',
            padding: '7px 10px 7px 10px',
            width: '66%',
            outline: 'none',
            border: '1px solid #c6c6c6',
            borderRadius: 6,
            transition: '0.3s ease-in-out all'
        },
        '& .MuiDataGrid-columnHeader:focus-within,& .MuiDataGrid-cell:focus': {
            outline: 'none  !important'
        },
        '& .MuiDataGrid-editInputCell, .MuiDataGrid-editInputCell input': {
            margin: 0,
            // padding: '0 !important',
            padding: '7px 4px 7px 4px  !important',
            FontFace: 'Lato, sans-serif !important',
            fontSize: '12px'
        },
        '& .MuiToolbar-gutters p': {
            margin: 0
        },
        '& .MuiTablePagination-select': {
            padding: "4px 0 2px", fontSize: '0.75rem'
        },
        '& .MuiDataGrid-cell.MuiDataGrid-cell--editing': {
            padding: '0 10px !important'
        },
        '& [data-field="actions"]': {
            textAlign: 'center'
        },
        '& div.MuiDataGrid-toolbarContainer': {
            display: 'flex',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            justifyContent: 'flex-start'
        },
        '& div.MuiDataGrid-toolbarContainer .MuiBox-root': {
            display: 'none'
        },
        '& .MuiButtonBase-root.MuiButton-root.MuiButton-text': {
            color: 'inherit', fontSize: '0.75rem'
        }
    }
});
const StyledGridFilterPanel = styled(GridFilterPanel)(({ theme }) => ({
    '& button.MuiButton-root:has(svg[data-testid="DeleteIcon"])': {
        // display: 'none',
      
    },
    '& .MuiDataGrid-panelFooter': {
        justifyContent:'flex-start !important'
    }
}));

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#2c2c2c',  // Dark black
        color: '#fff',               // White text
        fontSize: '13px',
        fontWeight: 600,
        borderRadius: '4px',
        boxShadow: 'none',
        padding: '6px 10px',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#2c2c2c',
    },
}));

const CustomFooter = ({ footerMessage, hidePagination }) => {
    return (
        <GridFooterContainer sx={{ display: 'flex', justifyContent: 'space-between', padding: '8px 16px' }}>

            <Typography variant="body2" sx={{ fontSize: '13px' }}>{footerMessage}</Typography>
            {!hidePagination && (
                <GridPagination
                    SelectProps={{
                        inputProps: {
                            name: 'data-grid-rows-per-page'
                        }
                    }}
                />
            )}
        </GridFooterContainer>
    );
};
function EnhancedDataGrid(props) {

    //#region variables
    const serverExport = React.useMemo(() => props.serverExport, [props.serverExport])
    const [disableTooltip, setDisableTooltip] = React.useState(false);

    //#region local variables
    //#end region

    const apiRef = useGridApiRef();
    let [pageSize, setPageSize] = useState(props.pageSize || 10)
    const [allVisbleColumn, setAllVisibleColumn] = React.useState(true);
    const [filterText, setFilterText] = useState(props?.filterText || '');
    const [filterModel, setFilterModel] = useState({
        items: [],
        quickFilterValues: [props?.filterText || ''],
        logicOperator: 'and'
    });
    const [isFiltered, setIsFiltered] = useState(1);
    const [initialLoad, setInitialLoad] = useState(1);
    const [isFilterMenuOpen, setIsFilterMenuOpen] = useState(false);
    // New UI (R18): the Filters and Columns panels open beside the button that opened them, not at the far end.
    const panelAnchorRef = React.useRef(null);
    const [panelPlacement, setPanelPlacement] = useState('bottom-end');
    React.useEffect(() => {
        if (!isNewUi()) return undefined;
        const onClick = e => {
            const root = apiRef.current && apiRef.current.rootElementRef ? apiRef.current.rootElementRef.current : null;
            const btn = e.target && e.target.closest ? e.target.closest('button') : null;
            if (!root || !btn || !root.contains(btn) || !btn.closest('.MuiDataGrid-toolbarContainer, .apw2-params, #dataGridtitle')) return;
            panelAnchorRef.current = btn;
            const r = btn.getBoundingClientRect(), g = root.getBoundingClientRect();
            setPanelPlacement(r.left + r.width / 2 < g.left + g.width / 2 ? 'bottom-start' : 'bottom-end');
        };
        document.addEventListener('click', onClick, true);
        return () => document.removeEventListener('click', onClick, true);
    }, [apiRef]);
    const [filterSnapshot, setFilterSnapshot] = useState(null); // Snapshot of filters when panel opens

   
    React.useEffect(() => {

        if (props?.filterMode === 'server') {
            let filterValue = filterModel?.quickFilterValues.join(' ') || '';
            let _isFiltered = isFiltered;
            if (isFiltered) {
                _isFiltered = 0;
            }
            if (initialLoad) {
                _isFiltered = 1;
            }
            if (!_isFiltered && !filterValue && !initialLoad) {
                if (props?.searchCallback && typeof props?.searchCallback === 'function') {
                    props?.searchCallback('')
                    _isFiltered = 1;
                }
            }
            setIsFiltered(_isFiltered);
        }

        if (initialLoad) {
            setInitialLoad(0);
        }
    }, [filterModel?.quickFilterValues]);

    React.useEffect(() => {
        if (!initialLoad) {
            if (isFilterMenuOpen) {
                setFilterSnapshot({ items: [...filterModel.items], logicOperator: filterModel.logicOperator }); // Store the snapshot of filters when the panel opens
            } else {
                // Panel just closed, compare old snapshot and new filters
                if (JSON.stringify(filterSnapshot) !== JSON.stringify({ items: [...filterModel.items], logicOperator: filterModel.logicOperator })) {
                    let updatedModel = {
                        ...filterModel
                    };
                    (props?.setFilterModel && props?.setFilterModel(updatedModel));
                    if (props?.filterMode === 'server') {
                        toolbarmethods.customFilters(updatedModel)
                    }

                }
            }
        }


    }, [isFilterMenuOpen]);


    const onPageSizeChange = useCallback((newPageSize) => {
        if (props.onPageSizeChange && typeof (props.onPageSizeChange) == 'function') {
            props.onPageSizeChange(newPageSize)
        }
        setPageSize(newPageSize)
    }, [props.onPageSizeChange]);
    const onSelectionModelChange = useCallback((model) => {
        if (props.onSelectionChange && typeof (props.onSelectionChange) == 'function') {
            let selectedRows = [];
            (props.apiRef || apiRef).current.getSelectedRows().forEach((e) => {
                selectedRows.push(e);
            })
            props.onSelectionChange(selectedRows);
        }
    });
    const toolbarmethods = React.useMemo(() => {
        return {
            getfiltertext: (text) => {
                setFilterText(text);
                if (props?.setFilterText && typeof props?.setFilterText === 'function') {
                    props?.setFilterText(text);
                }
            },
            serverFilter: (input, sender) => {
                const filterValue = filterModel?.quickFilterValues.join(' ') || '';

                // ✅ lock tooltip only on first actual search (not empty)
                if (!disableTooltip && filterValue.trim() !== '') {
                    setDisableTooltip(true); // 🔒 lock it forever
                }

                if (props?.searchCallback && typeof props?.searchCallback === 'function') {
                    if (sender === 'filter') {
                        props?.searchCallback((input === '') ? input : filterValue);
                    } else {
                        if (filterValue || !isFiltered) {
                            props?.searchCallback(filterValue);
                        }
                    }
                    setIsFiltered(1);
                }
            },

            customFilters: () => {
                if (props?.customServerFilter && typeof props?.customServerFilter === 'function') {
                    props?.customServerFilter(filterModel)
                    setIsFiltered(1);
                }
            },
            downloadcsv: () => {
                props?.exportServerCallback();
            },
            onSearchFocus: props?.onSearchFocus

        }
    }, [filterModel, isFiltered, props?.exportServerCallback])
    const onColumnVisbilityModelChange = React.useCallback((newModel) => {
        if (props?.options?.columnsButton) {
            let modelLength = Object.keys(newModel).length;
            let someChecked = Object.keys(newModel).some(e => newModel[e]);
            let isAllVisible = modelLength === 0 || someChecked
                || (!someChecked && modelLength < props.columns.length);
            setAllVisibleColumn(isAllVisible);
        }

        if (typeof props.onColumnVisbilityModelChange == "function") {
            props.onColumnVisbilityModelChange(newModel);
        }
    }, [props]);


    const expandIcon = useCallback(() => {
        return <ExpandMoreIcon
            sx={{
                transform: 'rotate(270deg)',
                transition: (theme) =>
                    theme.transitions.create('transform', {
                        duration: theme.transitions.duration.shortest,
                    }),
            }}
            fontSize="inherit"
        />
    }, []);
    const collapeIcon = useCallback(() => {
        return <ExpandMoreIcon
            sx={{
                transform: 'rotate(0deg)',
                transition: (theme) =>
                    theme.transitions.create('transform', {
                        duration: theme.transitions.duration.shortest,
                    }),
            }}
            fontSize="inherit"
        />
    }, []);

    useImperativeHandle(props.gridRef, () => {
        return {
            ...apiRef.current,
            filterText: filterText,
            pageSize: pageSize
        }
    }, [pageSize, filterText, apiRef.current]);
    var psize = pageSize;
    var pagingOptions = [5, 10, 20, 50, 100];
    if (props.rowsPerPageOptions) {
        pagingOptions = props.rowsPerPageOptions;
    }


    const filterModelCallback = React.useCallback((newModel) => {

        //if (filterModel.quickFilterValues?.length > 0 && newModel.quickFilterValues?.length === 0 && !isFiltered) {
        //    toolbarmethods.serverFilter('', 'filter')
        //}

    
        const prevQuick = filterModel?.quickFilterValues || [];
        const prevText = (prevQuick.join(' ') || '').trim();
        const newText = (newModel.quickFilterValues?.join(' ') || '').trim();

        const isClearingQuickFilter =
            prevText.length > 0 &&      
            newText === '' &&              
            toolbarmethods?.onSearchFocus;


        if (isClearingQuickFilter) {
            toolbarmethods.onSearchFocus();
        }

        toolbarmethods.getfiltertext(newModel.quickFilterValues?.join(' ') || '');
        setFilterModel(newModel);

        if (props?.onFilterModelChange && typeof props.onFilterModelChange === 'function') {
            props.onFilterModelChange(newModel);
        }

    }, [filterModel, isFiltered, isFilterMenuOpen, toolbarmethods])

    const renderFilterPanel = useCallback((panelProps) => {
        return props.customFilterPanel
            ? <MemoizedFilterPanel {...panelProps} onSearchClick={props.onFilterPanelSearch} />
            : <StyledGridFilterPanel {...panelProps} />;
    }, [props.customFilterPanel, props.onFilterPanelSearch]);


    const gridSx = React.useMemo(() => ({
        ...props.sx,
        ...(props.autoHeight
            ? {
                '& .MuiDataGrid-main': {
                    height: 'auto'
                }
            }
            : {
                '& .MuiDataGrid-main': {
                    height: typeof props.height === 'number'
                        ? `${props.height}px`
                        : (props.height || '560px')
                }
            }),
        '& .MuiDataGrid-cell:focus,& .MuiDataGrid-cell.MuiDataGrid-cell--editing:focus-within,& .MuiDataGrid-cell:focus-within': {
            outline: 'none !important', padding: '0 10px !important'
        },
        '& .MuiDataGrid-columnHeader': {
            outline: 'none !important'
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
            height: '0.7em',
            width: '0.7em'
        },
        '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:vertical , .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:horizontal': {
            background: '#B2b2b2', borderRadius: 2, opacity: '0.5'
        }
    }), [props.sx, props.autoHeight, props.height]);

    const initialState = React.useMemo(() => ({
        ...props.initialState,
        pagination: { paginationModel: { pageSize: psize } },
        filter: {
            filterModel: {
                items: [],
                quickFilterExcludeHiddenColumns: false,
            },
        },
    }), [props.initialState, psize]);

    // New UI only: status dots, columns that may grow, 44px rows and a helpful empty state (redesign/grid/gridLook.js).
    const newUi = isNewUi();
    const newUiGridProps = React.useMemo(() => (newUi ? {
        columns: datedColumns(relaxColumns(isSetupPage() ? setupColumns(props.columns) : isDashboardPage() ? dashboardColumns(props.columns) : props.columns)),
        getCellClassName: withStatusClass(props.getCellClassName),
        initialState: pinActions(initialState, props.columns),
        ...(props.rowHeight == null && !props.getRowHeight ? { rowHeight: 44 } : {}),
        ...(props.columnHeaderHeight == null ? { columnHeaderHeight: 44 } : {}),
        // Setup lists are as tall as their rows, so a short list doesn't leave a tall empty grid (R16)
        ...(isSetupPage() && !props.autoHeight ? { autoHeight: true, sx: { ...gridSx, '& .MuiDataGrid-main': { height: 'auto' } } } : {})
    } : null), [newUi, props.columns, props.getCellClassName, props.rowHeight, props.getRowHeight, props.columnHeaderHeight, props.autoHeight, initialState, gridSx]);

    const slots = React.useMemo(() => ({
        ...(newUi ? { noRowsOverlay: NoRowsOverlay, noResultsOverlay: NoRowsOverlay } : {}),
        ...props.slots,
        toolbar: DataGridTitle,
        detailPanelExpandIcon: expandIcon,
        detailPanelCollapseIcon: collapeIcon,
        filterPanel: renderFilterPanel,
        footer: () => <CustomFooter footerMessage={props.footerMessage} hidePagination={props.hidePagination} />,
    }), [newUi, props.slots, expandIcon, collapeIcon, renderFilterPanel, props.footerMessage, props.hidePagination]);

    const slotProps = React.useMemo(() => ({
        ...props.slotProps,
        baseCheckbox: {
            ...props.slotProps?.baseCheckbox,
            inputProps: {
                ...props.slotProps?.baseCheckbox?.inputProps,
                name: 'data-grid-row-selection'
            }
        },
        panel: newUi ? {
            placement: panelPlacement,
            anchorEl: () => (panelAnchorRef.current && panelAnchorRef.current.isConnected ? panelAnchorRef.current
                : apiRef.current && apiRef.current.columnHeadersContainerElementRef ? apiRef.current.columnHeadersContainerElementRef.current : null)
        } : {
            placement: "bottom-end"
        },
        filterPanel: {
            disableAddFilterButton: false,
            disableRemoveAllButton: false,
        },
        toolbar: {
            apiRef: apiRef,
            title: props.title,
            tooltipMessage: props.toolTipMessage,
            hasSearchedOnce: props.hasSearchedOnce,
            showSearchTooltip: props.showSearchTooltip && !disableTooltip,
            searchButton: props.searchButton,
            showSearchButtonInToolbar: props.showSearchButtonInToolbar,
            showquickfilter: props.nofilter ? 0 : 1,
            leftCustomComponent: props.leftCustomComponent || null,
            customcomponent: props.customcomponent || null,
            paramsbar: props.paramsbar ?? (newUi && /^\/reports\//i.test(window.location.pathname) && props?.options?.filtering ? true : undefined), // new UI reports: a settings bar (redesign/grid/ParamsBar.js); every report with filters has one (R18)
            paramlabels: props.paramlabels,
            printoptions: {
                disableToolbarButton: true
            },
            isallcolumnvisible: allVisbleColumn ? 1 : 0,
            columnsselector: props?.options?.columnsButton?.toString(),
            filtering: props?.options?.filtering?.toString(),
            csvbutton: props?.options?.exportButton?.toString(),
            toolbarmethods: toolbarmethods,
            filtermode: (props?.filterMode || ''),
            serverexport: (serverExport ? '1':'0'),
            filterref: toolbarmethods,
            csvoptions: {
                allColumns: !props?.options?.exportAllData,
                fileName: props?.options?.exportFileName,
                disableToolbarButton: !props?.options?.exportButton
            },
            filterText: props.filterText,
            isWeeksToFilterSearchActive: props.isWeeksToFilterSearchActive,
            highlightSearchTextOnMainScreenGrid: props?.highlightSearchTextOnMainScreenGrid || false,
            quickFilterDebounceMs: props.quickFilterDebounceMs
        }
    }), [props.slotProps, props.title, props.toolTipMessage, props.hasSearchedOnce, props.showSearchTooltip,
        props.searchButton, props.showSearchButtonInToolbar, props.nofilter, props.leftCustomComponent,
        props.customcomponent, props.paramsbar, props.paramlabels, props.options, props.filterMode, props.filterText, props.isWeeksToFilterSearchActive,
        props.highlightSearchTextOnMainScreenGrid, props.quickFilterDebounceMs, disableTooltip, allVisbleColumn,
        toolbarmethods, serverExport, apiRef, newUi, panelPlacement]);

    const onStateChange = useCallback((state) => {
        const panelProps = state.preferencePanel;
        const nextValue = !!(panelProps?.openedPanelValue && panelProps.open);
        setIsFilterMenuOpen(previousValue => previousValue === nextValue ? previousValue : nextValue);
    }, []);

    return (
        <DataGridPro
            {...props}
            paramsbar={undefined} // new UI report props go to the toolbar (slotProps), not the grid's DOM
            paramlabels={undefined}
            autoHeight={props.autoHeight ?? false}
            sx={gridSx}
            apiRef={props.apiRef || apiRef}
            className={props.classes.root}
            initialState={initialState}
            pageSizeOptions={pagingOptions}
            disableColumnFilter={!props?.options?.filtering}
            disableColumnSelector={!props?.options?.columnsButton}
            disableDensitySelector
            disableRowSelectionOnClick
            disableColumnMenu
            onPageSizeChange={onPageSizeChange}
            checkboxSelection={props && props.onSelectionChange && typeof (props.onSelectionChange) === 'function'}
            onRowSelectionModelChange={onSelectionModelChange}
            onFilterModelChange={filterModelCallback}

            // ✅ ALLOW INJECTING CUSTOM PANELS LIKE filterPanel
            slots={slots}

            // ✅ ALLOW SLOT PROPS TO BE EXTENDED FROM OUTSIDE
            slotProps={slotProps}

            onColumnVisibilityModelChange={onColumnVisbilityModelChange}
            onStateChange={onStateChange}
            {...newUiGridProps}
        />
    );

}
function DataGridTitle(props) {
    let max_size = 12;
    let column_size = 5 - (props.customcomponent && 1 || 0) - (props.filtering && 1 || 0) - (props.columnsselector && 1 || 0) - (props.csvbutton && 1 || 0);
    let columns_size_2 = max_size - column_size;
    let toolbarSize = 4 + Math.floor((props.filtering && 0.5 || 0) + (props.columnsselector && 0.5 || 0) + (props.csvbutton && 0.5 || 0))
    // New UI only: hooks for the one-row toolbar layout in redesign.css (search first, filters, then actions).
    const nu = isNewUi();
    const hook = name => (nu ? name : undefined);
    // New UI: a list's "Last Updated: …" title shows as a quiet note beside its actions instead of before the search.
    const fresh = nu && typeof props.title === 'string' && /^Last Updated:/i.test(props.title)
        ? <span className="apw2-fresh"><i aria-hidden="true" />Last updated {formatDateText(props.title.replace(/^Last Updated:\s*/i, '')) || '—'}</span> : null;
    const params = nu && !!props.paramsbar;
    return (
        <div style={{ width: '100%' }} id="dataGridtitle" className={nu ? 'apw2-gt' + (props.title || props.leftCustomComponent ? '' : ' apw2-gt-notitle') : undefined}>
            {params && <ParamsBar customcomponent={props.customcomponent} labels={props.paramlabels} />}
            <Grid key={1} item sx={{ pt: 1, pl: 1, pr: 1, pb: 1 }} container xs={12}>
                <Grid key={1} sx={{
                    '&': {
                        display: 'flex', marginTop: '10px !important',
                        alignItems: 'center', height: 'fit-content'
                    }
                }} item xs={column_size} className={hook('apw2-gt-title')}>
                    <div style={{ width: "100%", display: "flex", textOverflow: 'elipses', }}>
                        {(props.leftCustomComponent) ? (
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
                                {props.leftCustomComponent }
                            </div>
                        ) : null}
                        <Typography key={1} style={{
                            width: 'calc(100% - 0px)',
                            maxWidth: 'calc(100% - 0px)',
                            paddingLeft: '10px',
                            overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'
                        }}
                            title={props.title}
                            variant="h6">{props.title}</Typography>
                    </div>
                </Grid>
                <Grid key={2} item xs={columns_size_2} className={hook('apw2-gt-tools')}>
                    <div style={{ width: '100%' }}>
                        <Grid key={1} container item xs={12} justifyContent="flex-end" className={hook('apw2-gt-row')}>
                            <Grid key={1} sx={{ pr: (props.customcomponent) ? 1 : 0 }}
                                style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}
                                item xs={(props.customcomponent) ? toolbarSize : 12} alignItems="flex-end" className={hook('apw2-gt-search')}>
                                <GridCustomToolBar
                                    key={1}
                                    sx={{
                                        '& .MuiInput-underline:before': {
                                            borderBottom: '1px solid rgba(0, 0, 0, 0.42) !important'
                                        },
                                        '& .MuiFormControl-root[aria-label="Search"]': {
                                            paddingBottom: '2px'
                                        }
                                    }}
                                    apiRef={props.apiRef}
                                    title={props.title}
                                    tooltipMessage={props.tooltipMessage}
                                    hasSearchedOnce={props.hasSearchedOnce}
                                    filterText={props.filterText}
                                    isWeeksToFilterSearchActive={props.isWeeksToFilterSearchActive}
                                    highlightSearchTextOnMainScreenGrid={props.highlightSearchTextOnMainScreenGrid}
                                    showSearchTooltip={props.showSearchTooltip}
                                    toolbarmethods={props.toolbarmethods}
                                    filtermode={props.filtermode}
                                    searchButton={props.searchButton}
                                    showSearchButtonInToolbar={props.showSearchButtonInToolbar}
                                    csvbutton={props.csvbutton}
                                    csvoptions={props.csvoptions}
                                    columnsselector={props.columnsselector}
                                    filtering={props.filtering}
                                    isallcolumnvisible={props.isallcolumnvisible}
                                    printoptions={props.printoptions}
                                    customcomponent={props.customcomponent}
                                    showquickfilter={props.showquickfilter}
                                    nofilter={props.nofilter}
                                    serverexport={props.serverexport}
                                    quickFilterDebounceMs={props.quickFilterDebounceMs}

                                />

                            </Grid >
                            {
                                (props.customcomponent && !params) ?
                                    <Grid key={2} alignItems="center" className={hook('apw2-gt-custom')}>
                                        {props.customcomponent}
                                        {fresh}
                                    </Grid> : (fresh || <></>)
                            }
                        </Grid>
                    </div>
                </Grid>
            </Grid>
            {isNewUi() && !params && <ActiveFilterChips />}
        </div>
    )

}
function GridCustomToolBar({
    apiRef,
    sx,
    tooltipMessage,
    hasSearchedOnce,
    showSearchTooltip,
    toolbarmethods,
    searchButton,
    showSearchButtonInToolbar,
    filtermode,
    csvbutton,
    csvoptions,
    columnsselector,
    filtering,
    isallcolumnvisible,
    printoptions,
    customcomponent,
    showquickfilter,
    serverexport,
    nofilter,
    filterref,
    filterText,
    isWeeksToFilterSearchActive,
    highlightSearchTextOnMainScreenGrid,
    ...muiProps
}) {
    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const intervalRef = React.useRef(null);
    const timeoutRef = React.useRef(null);
    const hasSearchedOnce_ = React.useRef(false); 
    const areFiltersAppliedOnSearch = apiRef.current?.state?.filter?.filterModel?.quickFilterValues ?? false;

    // For debounced quickfilter: opt-in debounce controls
    const { quickFilterDebounceMs } = muiProps;
    const debounceMs =
        typeof quickFilterDebounceMs === 'number' && quickFilterDebounceMs > 0
            ? quickFilterDebounceMs
            : null;
    const useDebounce = !!debounceMs;

    const [inputValue, setInputValue] = React.useState(filterText || '');
    const typingTimerRef = React.useRef(null);

    React.useEffect(() => {
        if (!useDebounce) return;
        const current =
            apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') ||
            muiProps?.filterText ||
            '';
        setInputValue(current);
    }, [useDebounce, muiProps?.filterText]);



    // For debounced quickfilter: If grid quick filter is cleared (via ✕), also clear input + storage
    React.useEffect(() => {
        if (!useDebounce) return;

        const handleFilterModelChange = (model) => {
            const q = (model?.quickFilterValues?.join(' ') || '');
            setInputValue(q);
            toolbarmethods?.getfiltertext?.(q);  // keep storage aligned with the grid
            if (q === '' && typingTimerRef.current) clearTimeout(typingTimerRef.current);
        };

        const unsub1 = apiRef.current?.subscribeEvent?.('filterModelChange', handleFilterModelChange);
        const unsub2 = apiRef.current?.subscribeEvent?.('stateChange', (state) => {
            const q = (state?.filter?.filterModel?.quickFilterValues?.join(' ') || '');
            setInputValue(q);
        });

        return () => { unsub1?.(); unsub2?.(); };
    }, [useDebounce]);



    React.useEffect(() => {
        if (!showSearchTooltip || hasSearchedOnce) {
            setTooltipOpen(false);
            return;
        }
        setTooltipOpen(true);
        timeoutRef.current = setTimeout(() => {
            setTooltipOpen(false);
        }, 30000);

        intervalRef.current = setInterval(() => {
            let searchValue = apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') || '';
            if (!hasSearchedOnce && searchValue.trim() === '') {
                setTooltipOpen(true);
                if (timeoutRef.current) clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => {
                    setTooltipOpen(false);
                }, 20000);
            }
        }, 45000);

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [showSearchTooltip, hasSearchedOnce]); 


    // For debounced quickfilter: store immediately; filter after debounce
    const handleChangeDebounced = (event) => {
        const value = event.target.value;
        setInputValue(value); 

        if (typingTimerRef.current) clearTimeout(typingTimerRef.current);
        typingTimerRef.current = setTimeout(() => {
            if (muiProps?.filtermode !== 'server') {
                apiRef.current?.setQuickFilterValues?.([value]);
            }
            toolbarmethods?.getfiltertext?.(value);
        }, debounceMs);

        if (tooltipOpen) {
            setTooltipOpen(false);
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }
    };

    // For debounced quickfilter:
    const handleSubmitDebounced = (event) => {
        if (event.key === 'Enter' || event.key === 'Tab') {
            if (typingTimerRef.current) clearTimeout(typingTimerRef.current);
            const value = (inputValue ?? '').trim();
            if (value !== '') hasSearchedOnce_.current = true;

            apiRef.current?.setQuickFilterValues?.([value]); 
            toolbarmethods?.getfiltertext?.(value);         
            toolbarmethods?.serverFilter?.(value);           

            event.preventDefault?.();
            clearInterval?.(intervalRef.current);
            clearTimeout?.(timeoutRef.current);
            setTooltipOpen(false);
        }
    };
    //For debounced quickfilter:
    const handleSearchClickDebounced = () => {
        if (typingTimerRef.current) clearTimeout(typingTimerRef.current);
        const value = (inputValue ?? '').trim();
        if (value !== '') {
            hasSearchedOnce_.current = true;
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            setTooltipOpen(false);
        }
        apiRef.current?.setQuickFilterValues?.([value]); 
        toolbarmethods?.getfiltertext?.(value);          
        toolbarmethods?.serverFilter?.(value);         
    };



    const handleChange = (event) => {
        const value = event.target.value;
        if (apiRef.current?.setQuickFilterValues) {
            apiRef.current.setQuickFilterValues([value]);
        }
        //setSearchValue(value);
       

        if (tooltipOpen) {
            setTooltipOpen(false);
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        }

        toolbarmethods?.getfiltertext(value);
    };
    const handleSubmit = (event) => {
        let searchValue = apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') || '';
        if (event.key === 'Enter' || event.key === 'Tab') {
            if (searchValue.trim() !== '') {
                hasSearchedOnce_.current = true;
            }

            toolbarmethods?.getfiltertext(searchValue);
            toolbarmethods?.serverFilter(searchValue);
            event.preventDefault();
            clearInterval(intervalRef.current);
            clearTimeout(timeoutRef.current);
            setTooltipOpen(false);
        }
    };
    const handleSearchClick = () => {
        let searchValue = apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') || '';
        const trimmed = searchValue.trim();
        if (trimmed !== '') {
            hasSearchedOnce_.current = true;

            //  Manually stop tooltip cycle IMMEDIATELY
            if (intervalRef.current) clearInterval(intervalRef.current);
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            setTooltipOpen(false);
        }

        toolbarmethods?.getfiltertext(trimmed);
        toolbarmethods?.serverFilter(trimmed);
    };
    return (
        <GridToolbarContainer sx={{ ...sx, display: 'flex', alignItems: 'center', gap: '12px' }} {...muiProps}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <CustomTooltip
                    title={tooltipMessage || ''}
                    placement="top"
                    open={tooltipOpen}
                    disableHoverListener
                    disableFocusListener
                    disableTouchListener
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {showquickfilter == 1 && (areFiltersAppliedOnSearch ?
                            (
                                <GridToolbarQuickFilter
                                    // value={searchValue}
                                    InputProps={{
                                        inputProps: {
                                            name: 'data-grid-quick-filter'
                                        }
                                    }}
                                    sx={{
                                        backgroundColor: (
                                            typeof isWeeksToFilterSearchActive !== 'undefined'
                                                ? (isWeeksToFilterSearchActive ? 'rgba(0, 140, 205, 0.12)' : 'transparent')
                                                : (
                                                    (highlightSearchTextOnMainScreenGrid && apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ').trim()?.length > 0)
                                                        ? 'rgba(0, 140, 205, 0.12)'
                                                        : 'transparent'
                                                )
                                        ),
                                        "& input": {
                                            backgroundColor: 'transparent',
                                            height: '32px'
                                        }
                                    }}
                                    onFocus={toolbarmethods?.onSearchFocus ? () => toolbarmethods.onSearchFocus() : undefined}
                                    value={useDebounce
                                        ? inputValue
                                        : (apiRef.current?.state?.filter?.filterModel?.quickFilterValues?.join(' ') || '')}
                                    onChange={useDebounce ? handleChangeDebounced : handleChange}
                                    onKeyDown={useDebounce ? handleSubmitDebounced : handleSubmit}
                                />
                            ) : (
                                <GridToolbarQuickFilter quickFilterParser={(searchInput) => {
                                    filterref?.getfiltertext(searchInput);
                                    return searchInput
                                        .split(',')
                                        .map((value) => value.trim())
                                        .filter((value) => value !== '')

                                }
                                }
                                    InputProps={{
                                        inputProps: {
                                            name: 'data-grid-quick-filter'
                                        }
                                    }}
                                    sx={{
                                        backgroundColor:
                                            (typeof isWeeksToFilterSearchActive !== 'undefined'
                                                ? (isWeeksToFilterSearchActive ? 'rgba(0, 140, 205, 0.12)' : 'transparent')
                                                :
                                                (typeof filterText !== 'undefined' && filterText.trim() !== ""
                                                ? "rgba(0, 140, 205, 0.12)"
                                                : "transparent")
                                            ),
                                        "& input": {
                                            backgroundColor: 'transparent',
                                            height: '32px',
                                        }
                                    }}
                                ></GridToolbarQuickFilter>))}
                     
                        {showSearchButtonInToolbar && searchButton && (
                            <div onClick={useDebounce ? handleSearchClickDebounced : handleSearchClick}>{searchButton}</div>
                        )}
                    </div>
                </CustomTooltip>
            </div>

            {/* Standard Toolbar Buttons */}
            {serverexport =='1' ? (
                <ServerExport toolbarmethods={toolbarmethods} csvbutton={csvbutton} />
            ) : (
                <GridCustomToolBarExport
                    csvoptions={csvoptions}
                    printoptions={printoptions}
                    isallcolumnvisible={isallcolumnvisible}
                />
            )}

            <GridToolbarColumnsButton />
            <GridCustomToolBarFilterButton isallcolumnvisible={isallcolumnvisible} />
        </GridToolbarContainer>
    );
}

function GridCustomToolBarExport(props) {
    return (
        !props.isallcolumnvisible ?
            <div onClick={(event) => { toast.error('At least 1 column should be visbile to export'); }}>
                <GridToolbarExport disabled={true}></GridToolbarExport>
            </div> :
            <GridToolbarExport csvOptions={props.csvoptions} printOptions={props.printoptions}></GridToolbarExport>);
}
function GridCustomToolBarFilterButton(props) {
    return (
        !props.isallcolumnvisible ?
            <div onClick={(event) => { toast.error('At least 1 column should be visbile to apply filter'); }}>
                <GridToolbarFilterButton disabled={true} {...props}></GridToolbarFilterButton>
            </div> :
            <GridToolbarFilterButton {...props} onClick={props.onClick}></GridToolbarFilterButton>
    )
}


function ServerExport(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);

    // Open the menu on left-click
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMenuClick = (type) => {
        handleClose();
        props?.toolbarmethods?.downloadcsv(type);
    };

    return (
        (props.csvbutton === 'true') ? (
            <>
                <Button
                    variant="text"
                    size="small"
                    startIcon={<FileDownloadOutlinedIcon />}
                    onClick={handleClick}  // Open menu instead of direct download
                >
                    {"Export"}
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem onClick={() => handleMenuClick('csv')}>{isNewUi() ? 'Download as CSV' : 'Export as CSV'}</MenuItem>
                </Menu>
            </>
        ) : <></>
    );
}

function DefaultFilterPanel(props) {
    const apiRef = useGridApiContext();

    const handleSearchClick = () => {
        const model = apiRef.current.state.filter.filterModel;
        const quickText = (model.quickFilterValues || [''])[0] || '';

        if (props?.onSearchClick) {
            props.onSearchClick(model, quickText);
        }
        apiRef.current.hideFilterPanel();
    };

    return (
        <div>
            <StyledGridFilterPanel {...props} />

            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: '8px 16px 12px calc(100% - 254.6px)',
                marginTop: '-47px'
            }}>


                <Button
                    variant="contained"
                    size="small"
                    startIcon={<SearchIcon/> }
                    style={isNewUi() ? undefined : {
                        backgroundColor: '#008ecd',
                        textTransform: 'none',
                        fontSize: '12px',
                        padding: '3px 10px',
                        minHeight: '28px',
                    }}
                    {...(isNewUi() ? { className: 'apw2-apply-filters' } : {})}
                    onClick={handleSearchClick}
                >
                    {isNewUi() ? 'Apply filters' : 'Search'}
                </Button>
            </div>
        </div>
    );
}

const MemoizedFilterPanel = React.memo(DefaultFilterPanel);


export default withStyles(Styles)(EnhancedDataGrid);